import { UiSchema } from '@rjsf/utils';
import { getFormatMappings } from '@tmt-insights/oms_fe_core/columns';

export const getUISchemaBBC = (schema): UiSchema => {
  const uiSchema: UiSchema = getFormatMappings(schema);
  if(schema.properties) {
    Object.keys(schema.properties).forEach((key) => {
      const property = schema.properties?.[key];
      if (!property) return; // Skip if property is undefined

      if (!uiSchema[key]) {
        uiSchema[key] = {};
      }
      if (property.ui_helper_text && property.description) {
        if (!uiSchema.properties) {
          uiSchema.properties = {};
        }
        if (!uiSchema.properties[key]) {
          uiSchema.properties[key] = {};
        }
        uiSchema.properties[key].ui_helper_text = undefined;
      }
      if (property.ui_helper_text) {
        uiSchema[key]['ui:help'] = property.ui_helper_text;
      }
      if (property.ui_placeholder) {
        uiSchema[key]['ui:placeholder'] = property.ui_placeholder;
      }
      if (property.anyOf || property.oneOf) {
        uiSchema[key]['ui:placeholder'] = '';
        uiSchema[key]['ui:title'] = property.title;
      }
      if (property.format) {
        const format = property.format;
        if (format === 'MultiLanguagePicker') {
          uiSchema[key]['ui:widget'] = 'MultiLanguagePicker';
        }
      }
    });
    }
return uiSchema;
}
